import {FaParking} from "react-icons/fa";
import React from "react";
import {ParkingFeeModel} from "./ParkingFeeModel";
import {createOrUpdateParkingFee} from "../../service/JobService";


export const ParkingFee = (props) => {
    const {job} = props;
    const [show, setShow] = React.useState(false);
    const [message, setMessage] = React.useState("")

    const handleSave = (e, parkingFeeData) => {
        e.stopPropagation()
        setMessage("")
        let payload = {
            ...job,
            description: parkingFeeData.description,
            fee: parkingFeeData.fee,
            id: parkingFeeData.id,
            image_ids: parkingFeeData.images.map(image => image.id)
        }
        createOrUpdateParkingFee(payload).then(response => {
            if (response.status === 200) {
                console.log("Parking Fee saved successfully")
                setMessage("Parking Fee saved successfully")
                handleClose(e)
                job.has_parking_fee = payload.fee > 0
            } else {
                response.json().then(data => {
                    setMessage(data.message)
                }).catch(error => {
                    setMessage("Error saving Parking Fee")

                })
                console.log("Parking Fee save failed")
            }
        })
    }

    const handleClose = (e) => {
        if (e) {
            e.stopPropagation()
        }
        setMessage("")
        setShow(false)
    }

    return (
        <>
            <FaParking style={{marginLeft: "10px", cursor: "pointer",color: job.has_parking_fee ? "red" : "grey"}}
                       size={22}
                       title={"Parking Fee"}
                       onClick={(e) => {
                           e.stopPropagation()
                           setShow(true)
                       }}
            /> {show &&
            <ParkingFeeModel
                show={show}
                job={job}
                handleSave={handleSave}
                handleClose={handleClose}
                message={message}
                setMessage={setMessage}
            />}
        </>
    )
}
